//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Code from './full-course-list-code.js'
import RestImgDummy from '~/components/rest-img-dummy'
import RestPropDummy from '~/components/rest-prop-dummy'
import RestStringDummy from '~/components/rest-string-dummy'


export default {
	...Code,

	components:
	{
		...Code.components,
		'rest-img': RestImgDummy,// RestImg,
		'rest-prop': RestPropDummy, // RestProp,
		'rest-string': RestStringDummy, // RestProp,
	}

}
